<template>
  <DropdownMenuRadioGroup
    v-if="!context.isMobile"
    :model-value="modelValue"
    class="flex flex-col"
    @update:model-value="update"
  >
    <slot />
  </DropdownMenuRadioGroup>
  <div v-else role="radiogroup" class="flex flex-col">
    <slot />
  </div>
</template>

<script setup lang="ts" generic="T extends string">
import { type AcceptableValue, DropdownMenuRadioGroup } from "reka-ui";

import { inject } from "./context";
import { provideRadioGroup } from "./radio-context";

const context = inject();

const props = defineProps<{
  modelValue: T;
}>();

const emit = defineEmits<{
  "update:modelValue": [value: T];
}>();

const update = (value: AcceptableValue) => {
  emit("update:modelValue", value as T);
};

provideRadioGroup({
  currentValue: () => props.modelValue,
  select: update,
});
</script>
